import RichTextStyleEditor from './RichTextStyleEditor';

export default RichTextStyleEditor;